import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, Button } from "antd";

import StyledContainer from "./style";

import { faArrowDown, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const PlaceholderChart = () => (
  <StyledContainer>
    <Flex justify="space-between" style={{ marginBottom: 5 }}>
      <Flex gap={4}>
        <Button size="small" type="text">
          1m
        </Button>
        <Button size="small" style={{ background: "#B9C6CC" }} type="text">
          3m
        </Button>
        <Button size="small" type="text">
          6m
        </Button>
        <Button size="small" type="text">
          YTD
        </Button>
        <Button size="small" type="text">
          1y
        </Button>
        <Button size="small" type="text">
          All
        </Button>
      </Flex>

      <span style={{ fontSize: 12 }}>
        28 Jun 2024 <FontAwesomeIcon icon={faArrowRight} /> 8 Oct 2024
      </span>
    </Flex>

    <section>
      <div className="container-message">
        <h5>Add Holdings below to start building a model</h5>
        <FontAwesomeIcon
          icon={faArrowDown}
          style={{ color: "#0D63CD", fontSize: 22 }}
        />
      </div>
    </section>

    <Flex justify="end" style={{ marginTop: 10 }}>
      <span
        style={{
          color: "#A5A3A3",
          fontSize: 12,
        }}
      >
        Source: Statestreet Inc.
      </span>
    </Flex>
  </StyledContainer>
);

export default PlaceholderChart;
